<template>
  <div>
    <!-- Toolbar -->
    <!-- <v-toolbar color="blue darken-3" dark dense flat>
      <v-icon class="mr-2">mdi-account-school</v-icon>
      <v-toolbar-title class="font-weight-bold subtitle-1">Mis Inscripciones Realizadas</v-toolbar-title>
    </v-toolbar> -->

    <!-- Panel de filtros -->
    <v-card class="ma-3" outlined>
      <v-card-title class="py-2 px-3 blue lighten-5 subtitle-2 blue--text text--darken-3">
        <v-icon small left color="blue darken-3">mdi-filter-outline</v-icon>
        Filtros de búsqueda::
      </v-card-title>
      <v-card-text class="pt-3 pb-2"> 
        <form @submit.prevent="validarDatos" novalidate>
          <v-row dense align="center">
            <v-col cols="12" sm="2">
              <v-text-field
                v-model="buscar"
                outlined dense
                prepend-inner-icon="mdi-magnify"
                label="Búsqueda rápida en la tabla"
                hide-details
                clearable>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <div class="fecha-field-wrap" :class="{ 'fecha-error': validation.hasError('busqueda.fecha_ini') }">
                <label class="fecha-label">
                  <v-icon x-small color="blue darken-2" class="mr-1">mdi-calendar-start</v-icon>
                  Inscripciones desde
                </label>
                <Fecha :model="busqueda" :valueto="'fecha_ini'" :default="busqueda.fecha_ini" />
                <div class="red--text caption" v-if="validation.hasError('busqueda.fecha_ini')">
                  {{ validation.firstError('busqueda.fecha_ini') }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" sm="2">
              <div class="fecha-field-wrap" :class="{ 'fecha-error': validation.hasError('busqueda.fecha_fin') }">
                <label class="fecha-label">
                  <v-icon x-small color="blue darken-2" class="mr-1">mdi-calendar-end</v-icon>
                  Inscripciones hasta
                </label>
                <Fecha :model="busqueda" :valueto="'fecha_fin'" :default="busqueda.fecha_fin" />
                <div class="red--text caption" v-if="validation.hasError('busqueda.fecha_fin')">
                  {{ validation.firstError('busqueda.fecha_fin') }}
                </div>
              </div>
            </v-col>
            <v-col cols="auto">
              <v-btn color="blue darken-3" dark rounded small type="submit">
                <v-icon small left>mdi-magnify</v-icon> Buscar
              </v-btn>
            </v-col>
            <v-col cols="auto" v-if="idfiltro>1 || ($store.state.CARGO.id==1 || $store.state.CARGO.id==3 || $store.state.CARGO.id==11 || $store.state.CARGO.id==12 || $store.state.CARGO.id>=17)">
              <router-link to="misinscripciones2" style="text-decoration: none">
                <v-btn color="success" rounded small>
                  <v-icon small left>mdi-account-search</v-icon> Buscar por asesor
                </v-btn>
              </router-link>
            </v-col>
            <v-col cols="auto">
              <v-btn
                v-show="inscripciones.length > 0"
                :disabled="$store.state.isonlyread"
                color="green darken-1" dark rounded small
                @click="tableToExcel('table', 'Inscritos')">
                <v-icon small left>mdi-microsoft-excel</v-icon> Descargar Excel
              </v-btn>
            </v-col>
          </v-row>
        </form>
      </v-card-text>
    </v-card>

    <div class="px-3">
      <!-- Barra de resultados + opción de columnas -->
      <v-row dense align="center" class="mb-2">
        <v-col>
          <span class="caption blue--text font-weight-medium" v-if="msg">
            <v-icon small color="blue darken-2" class="mr-1">mdi-information-outline</v-icon>
            {{ msg }}
          </span>
        </v-col>
        <!-- <v-col cols="auto">
          <v-checkbox
            v-model="contraercolumnas"
            label="Contraer columnas"
            hint="Ocultar columnas no necesarias"
            persistent-hint
            hide-details dense class="mt-0">
          </v-checkbox>
        </v-col> -->
      </v-row>

      <!-- Loading -->
      <div class="text-center py-8" v-show="loading">
        <v-progress-circular indeterminate color="blue darken-3" size="40"></v-progress-circular>
        <div class="caption grey--text mt-2">Cargando inscripciones...</div>
      </div>

      <!-- Tabla -->
      <div v-show="!loading" class="tabla-ins-wrapper mb-14">
        <table ref="table" class="tabla-ins" id="midatatable" summary="lorem ipsum sit amet">
          <caption v-show="false">
            Reporte de inscripciones: {{ nom_us }}, {{ fec_us }}
          </caption>
          <thead>
            <tr class="tabla-ins-header">
              <th>Nro</th>
              <th style="min-width:160px">Nombre completo</th>
              <!-- <th style="min-width:160px">Nombres</th>
              <th style="min-width:100px">Apellido 1</th>
              <th style="min-width:100px">Apellido 2</th> -->
              <th v-if="!contraercolumnas" style="min-width:90px">Documento</th>
              <th v-if="!contraercolumnas">Teléfono</th>
              <th v-if="!contraercolumnas">Correo</th>
              <th v-if="!contraercolumnas">Programa</th>
              <th v-if="!contraercolumnas">Sede</th>
              <th v-if="!contraercolumnas">Prospectado</th>
              <!-- <th v-if="!contraercolumnas">Estado</th> -->
              <th v-show="false">Tel. Fijo</th>
              <th v-show="false">Profesión</th>
              <th v-show="false">Observación</th>
              <th v-show="false">Universidad</th>
              <th v-show="false">Género</th>
              <th v-show="false">Domicilio</th>
              <th>Estado Adm</th>
              <th style="min-width:120px">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-bind:key="ins.id" v-for="(ins, ind) in inscripciones">
              <td :title="'ID inscripcion: ' + ins.id" class="nro-col">{{ ind + 1 }}</td>
              <td>{{ ins.estudiante.nombres }} {{ ins.estudiante.pri_apellido }} {{ ins.estudiante.seg_apellido }}</td>
              <!-- <td :title="'ID Estudiante: ' + ins.estudiante.id" class="font-weight-medium">{{ parseApellidos(ins.estudiante, 1) }}</td>
              <td :title="'ID Estudiante: ' + ins.estudiante.id">{{ parseApellidos(ins.estudiante, 2) }}</td> -->
              <td v-if="!contraercolumnas">{{ parseDoc(ins.estudiante) }}</td>
              <td v-if="!contraercolumnas">
                <a v-if="ins.estudiante.telefono1" href="#" @click="whatsapp(ins.estudiante.telefono1)" title="Abre whatsapp web" class="wsp-link">
                  <v-icon x-small color="green darken-2" class="mr-1">mdi-whatsapp</v-icon>{{ ins.estudiante.telefono1 }}
                </a>
              </td>
              <td v-if="!contraercolumnas">{{ ins.estudiante.email }}</td>
              <td v-if="!contraercolumnas" :title="ins.estudiante.nombres" style="max-width: 350px;min-width: 300px;text-wrap: inherit;">{{ parsePrograma(ins.programa) }}</td>
              <td v-if="!contraercolumnas">{{ parseSede(ins.programa) }}</td>
              <td v-if="!contraercolumnas">{{ parseFecha(ins.fecha_registro) }}</td>
              <!-- <td v-if="!contraercolumnas" :style="parseInsColor(ins.estado_ins)" class="estado-col">
                {{ parseIns(ins.estado_ins) }}
              </td> -->
              <td v-show="false">{{ ins.estudiante.telefono2 }}</td>
              <td v-show="false">{{ getProfesion(ins.estudiante.profesiones) }}</td>
              <td v-show="false">{{ getObservacion(ins.observaciones) }}</td>
              <td v-show="false">{{ getInstitucion(ins.estudiante.institucion) }}</td>
              <td v-show="false">{{ getGenero(ins.estudiante) }}</td>
              <td v-show="false">{{ ins.estudiante.domicilio }}</td>
              <td>
                <!-- <v-chip v-if="ins.estado_administrativo_id==1" color="grey" text="pros">prospecto</v-chip>
                <v-chip v-else-if="ins.estado_administrativo_id==2" color="orange" >Preinscrito</v-chip>
                <v-chip v-else-if="ins.estado_administrativo_id==3" color="green" >Inscrito</v-chip>
                <v-chip v-else color="grey" > {{ ins.estado_administrativo_id }} </v-chip> -->

                <span v-if="ins.estado_ins==0"> Preinscrito </span>
                <span v-else-if="ins.estado_ins==1"> inscrito </span>
                <span v-else> otros </span> 
              </td>
              <td> 
                <template v-if="idfiltro==1">
                  <v-tooltip bottom >
                    <template #activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on" :disabled="loadingpdf || (ins.estado_administrativo_id != 1 || ins.estado_ins != 0)" class="mr-2" @click="proceder_inscripcion(ins)" color="orange darken-1">
                        <v-icon>mdi-account-plus</v-icon>
                      </v-btn>
                    </template>
                    solicitar Pre inscripcion
                  </v-tooltip> 
                </template>

                <template v-else>
                  <v-tooltip bottom v-if="ins.estado_ins == 1">
                    <template #activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" :disabled="loadingpdf" @click="formulariopdf(ins)" color="blue darken-1">
                        <v-icon>mdi-download</v-icon>
                      </v-btn>
                    </template>
                    Formulario de inscripción
                  </v-tooltip>

                  <!-- <v-tooltip bottom v-if="ins.estado_ins == 1">
                    <template #activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" :disabled="loadingpdf" @click="ver_terminos(ins)" color="blue lighten-1">
                        <v-icon>mdi-download-circle</v-icon>
                      </v-btn>
                    </template>
                    Terminos y condiciones
                  </v-tooltip> -->

                  <v-tooltip bottom v-if="ins.estado_ins == 1 && is_ispi">
                    <template #activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" @click="open_expedientes(ins)" color="teal darken-1">
                        <v-icon small>mdi-folder-open</v-icon>
                      </v-btn>
                    </template>
                    Expedientes ISPI
                  </v-tooltip>

                  <v-tooltip bottom v-if="ins.estado_ins == 0">
                    <template #activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" @click="cambiarEstado(ins)" color="orange darken-1">
                        <v-icon small>mdi-swap-horizontal</v-icon>
                      </v-btn>
                    </template>
                    Cambiar a inscrito
                  </v-tooltip>

                  <!-- <v-tooltip bottom>
                    <template #activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" @click="subir_documentos(ins)" color="grey darken-1">
                        <v-icon small>mdi-file-upload</v-icon>
                      </v-btn>
                    </template>
                    Subir documentos
                  </v-tooltip> -->
                </template>

                <v-tooltip bottom>
                  <template #activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" :disabled="loadingpdf" @click="ver_historial_acad(ins)" color="purple darken-2">
                      <v-icon>mdi-clock</v-icon>
                    </v-btn>
                  </template>
                  Ver Historial academico
                </v-tooltip>

                <v-tooltip bottom vv-if="ins.estado_administrativo_id == 1 && ins.estado_ins == 1">
                  <template #activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" :disabled="loadingpdf" @click="verInscripciones(ins.programa)" color="blue darken-2">
                      <v-icon>mdi-account-details</v-icon>
                    </v-btn>
                  </template>
                  Ver lista de registros en el programa
                </v-tooltip>
                
                <v-tooltip bottom v-if="false">
                  <template #activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" :disabled="loadingpdf" @click="open_verificar_documento(ins)" color="green darken-2">
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  Verificar documento
                </v-tooltip>

                <v-progress-linear v-if="loadingpdf" indeterminate color="indigo" style="width:50px"></v-progress-linear>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <notifications group="auth" position="bottom right" />
    <notifications group="auth3" position="bottom right" />
    <div v-show="false"><Formulariopdf ref="formulariopdf" v-on:onmsgpdf="onmsgpdf" /></div>
    <Detalle id="modal" v-bind:obj="seleccionado" v-on:exito="modalExito" />
    <Cambio id="modalcam" :model="precambio" v-on:exito="modalExito" />
    <menuExp ref="refmenu" />
    <ver_historial ref="refver_historial" />
    <!-- <terminos_y ref="refterminos_y" /> -->
    <verificar_documento ref="refverificar_documento" />
  </div>
</template>

<script>
  import { generarInscripcionesR } from '@/components/generar-inscripciones.js';
  import { Validator } from 'simple-vue-validator';
  import Detalle from '@/components/ADetalleInscrito';
  import Formulariopdf from '@/components/AFormularioPDF.vue';
  import Cambio from '@/views/CambioPrograma';
  import Fecha from '@/components/AFecha.vue';
  import menuExp from '../components/expedientesispi/menu.vue';
  // import terminos_y from './prospectos1/terminos_y.vue';
  import ver_historial from './prospectos1/ver_historial.vue';
  import verificar_documento from './prospectos1/verificar_documento.vue';
  import { error, strFechaBusqueda, parseJsonError } from '@/components/Utils.js';
  import gql from 'graphql-tag';
  import xaxios from '@/xaxios';

  export default {
    props:{idfiltro:Number},
    data() {
      return {
        // EXCEL
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        },
        // END EXCEL
        buscar: '',
        msg: '',
        nom_us: '',
        fec_us: '',
        loadingpdf: false,
        loading: false,
        contraercolumnas: false,
        ispermitidoporasesor: false,
        idNewInscripcion: 0,
        seleccionado: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null },
        pagarMatricula: { id: -1 },
        precambio: { id: -1, idasesor: -1, ins: null },
        inscripciones: [],
        is_ispi: false,
        busqueda: {
          fecha_ini: null,
          fecha_fin: null,
        },
        param_idfiltro: null,
      };
    },
    components: { Cambio, Fecha, Detalle, Formulariopdf,menuExp,ver_historial,verificar_documento },
    validators: {
      'busqueda.fecha_ini'(value) {
        return Validator.value(value).required();
      },
      'busqueda.fecha_fin'(value) {
        return Validator.value(value).required();
      },
    },
    watch: {
      buscar: function () {
        this.myFunction1(this.buscar);
      },
      '$store.state.DATA_USER': function () {
        this.gen_nom_us();
      },
      'busqueda.fecha_ini': function () {
        this.parseFecha2();
      },
      'busqueda.fecha_fin': function () {
        this.parseFecha2();
      },
    },
    methods: {
      generarReporte() {
        generarInscripcionesR(this.inscripciones, this.busqueda, this.$store.state.DATA_USER);
      },
      formulariopdf(ins) {
        window.console.log(ins);
        this.$refs.formulariopdf.getpersonainfo(ins.estudiante.id, ins.programa.id, ins.id, this);
      },
      open_expedientes(ins){
        window.console.log(ins);
        this.$refs.refmenu.openmodal(ins);
      },
      gen_nom_us() {
        var data_user = this.$store.state.DATA_USER;
        if (!data_user) return;
        if (!data_user.seg_apellido) data_user.seg_apellido = '';
        this.nom_us = data_user.nombres + ' ' + data_user.pri_apellido + ' ' + data_user.seg_apellido;
      },
      parseFecha2() {
        var fe = this.busqueda.fecha_ini;
        var fe2 = this.busqueda.fecha_fin;
        if (!fe) fe = '- -';
        if (!fe2) fe2 = '- -';
        var vs = fe.split('-');
        var vs2 = fe2.split('-');
        this.fec_us = 'DEL: ' + vs[2] + '/' + vs[1] + '/' + vs[0] + ' AL ' + vs2[2] + '/' + vs2[1] + '/' + vs2[0];
      },
      tableToExcel(table, name) {
        if (!table.nodeType) table = this.$refs.table;
        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
        var link = document.createElement('a');
        link.download = 'inscripciones.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      parsePrograma(p) {
        if (p == null) return '';
        var cat = p.postgrado.categoria.nombre;
        var nom = p.nombre_compuesto;
        nom = nom.replace('- ' + cat, '- ');
        return nom;
      },
      parseEstudiante(e) {
        if (e == null) return '';
        var seg = e.seg_apellido;
        if (seg == null) seg = '';
        return e.nombres + ' ' + e.pri_apellido + ' ' + seg;
      },
      parseApellidos(e, unodos) {
        if (e == null) return '';
        var seg = e.seg_apellido;
        if (seg == null) seg = '';
        if (unodos == 1) return e.pri_apellido;
        else return seg;
      },
      getProfesion(profs) {
        if (!profs || profs.length == 0) return '-';
        var p = profs[0];
        return p.nombre;
      },
      getObservacion(ob) {
        if (!ob) return '';
        return ob;
      },
      getInstitucion(inst) {
        if (!inst) return '-';
        return inst.abreviatura + ' - ' + inst.nombre;
      },
      getGenero(est) {
        if (!est) return '-';
        return est.sexo;
      },
      parseSede(p) {
        if (p == null) return '';
        if (p.sede == null) return '-';
        return p.sede.nombre;
      },
      parseFecha(f) {
        var date = new Date(f);
        var a = date.getFullYear();
        var m = date.getMonth() + 1;
        var d = date.getDate();
        if (m < 10) m = '0' + m;
        if (d < 10) d = '0' + d;
        return d + '/' + m + '/' + a;
      },
      parseIns(ins) {
        var str = '';
        if (ins == 0) str = 'Pre inscrito';
        else if (ins == 1) str = 'Inscrito';
        else if (ins == 2) str = 'retirado';
        else if (ins == 3) str = 'cambiado';
        else if (ins == 4) str = 'congelado';
        else if (ins == 5) str = 'pagado';
        return str;
      },
      parseInsColor(ins) {
        if (ins == 0) return 'background:#EFFFA8';
        else if (ins == 1) return 'background:#A8FFA8';
        else if (ins == 2) return 'background:#FFA8B1';
        else if (ins == 3) return 'background:#FFE0A8';
        else if (ins == 4) return 'background:#A8D3FF';
        else if (ins == 5) return 'background:#FFA8F2';
        else return '';
      },
      parseDoc(es) {
        if (es == null) return ' ';
        else if (es.num_doc == null) return ' ';
        // var ext = '-';
        // if (es.departamento != null) ext = es.departamento.extension;
        return es.num_doc;
      },
      validarDatos() {
        this.inscripciones = [];
        this.msg = '';
        this.$validate().then((success) => {
          var obj = window.Object.assign({}, this.busqueda);
          if (success) {
            if (obj.fecha_ini == obj.fecha_fin) {
              this.$notify(error('Fechas invalidas', 'Las fechas deben tener al menos un dia de diferencia'));
              return;
            }
            this.loading = true;
            this.buscarInscripciones(obj);
          } else {
            this.loading = false;
          }
        });
      },
      buscarInscripciones(obj) {
        var vue = this;
        var sql = gql`query{ misInscripciones(fechas:${window.stringifyObject(obj)})
      { id,estado_ins,estado_administrativo_id,fecha_registro,asesor{id},estudiante{id,email,num_doc,telefono1,telefono2,usuario_moodle,clave_moodle,nombres,pri_apellido,seg_apellido,sexo,departamento{extension},ciudad{nombre},profesiones{id,nombre},estado,institucion{id,nombre,abreviatura},domicilio,fecha_nac,est_civil},programa{id,version,grupo,fecha_inicio,fecha_fin,sede{nombre},nombre_compuesto,postgrado{nombre,categoria{nombre}}}} }`;
        vue.msg = '';
        this.$apollo
          .query({
            query: sql,
          })
          .then((data) => { 
            /* let ambos = -1
            if(this.idfiltro == 2){
              ambos = 3
            } */
            // const nulos = this.idfiltro == 1 ? null : this.idfiltro
            // para contactos mkt descomentar esto
            // vue.inscripciones = data.data.misInscripciones.filter(x=>x.estado_administrativo_id==this.idfiltro || x.estado_administrativo_id == this.param_idfiltro || x.estado_administrativo_id == ambos).reverse();
            
            vue.inscripciones = data.data.misInscripciones.reverse();

            if (!vue.inscripciones) vue.inscripciones = [];
            this.msg = this.inscripciones.length + ' Resultados, del ' + strFechaBusqueda(vue.busqueda);
            this.loading = false;
          })
          .catch((error) => {
            this.msg = error;
            window.console.error(error);
            this.$notify(parseJsonError(error, 'misInscripciones'));
          });
      },
      modalExito() {},
      verDetalles(id) {
        var msg = 'Detalle de la inscripcion';
        var body = 'Detalles';
        var tag = gql`
        query{
          getInscripcion(id:${id}){
            id,estado_ins,observaciones,fecha_registro,matricula{monto,saldo},
            monto_colegiatura,monto_certificacion,
            cuotas,lista_cuotas{monto,saldo,fecha},certificacion{monto,saldo}
          }
        }
        `;
        this.seleccionado = { xid: 12, xtitle: msg, xbody: body, xsql: tag };
      },
      pagos(id) {
        window.sessionStorage.setItem('xins', JSON.stringify(id));
        window.sessionStorage.setItem('routerTo', 'misinscripciones');
        this.$router.push({ name: 'pagos' });
      },
      cambioPrograma(ins) {
        this.precambio.id = ins.id;
        this.precambio.idasesor = ins.asesor.id;
        this.precambio.ins = ins;
      },
      cambiarEstado(ins) {
        this.$store.dispatch('inscripcion/selectInscripcion', ins);
        ins.programa.estudiante_id = ins.estudiante.id;
        window.sessionStorage.setItem('xprograma', JSON.stringify(ins.programa));
        window.sessionStorage.setItem('xpreinscrito', JSON.stringify(ins));
        this.$router.push({ name: 'inscripcionrest' });
      },
      subir_documentos(){
        window.alert('funcionalidad aun en desarrollo')
      },
      generarplan(ins) {
        window.sessionStorage.removeItem('xpreinscrito');
        window.sessionStorage.setItem('xprograma', JSON.stringify(ins.programa));
        window.sessionStorage.setItem('xinscritotoplan', JSON.stringify(ins));
        this.$router.push({ name: 'inscripcionrest' });
      },
      whatsapp(tel) {
        window.open(`${process.env.VUE_APP_API_WHATSAPP}591` + tel + '&text=Hola');
      },
      getFechasDefault(xparam_idfiltro=null) {
        this.param_idfiltro = -1;
        if(xparam_idfiltro){
          this.param_idfiltro = xparam_idfiltro;
        }
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth() + 1;
        if (d == 1) d = 2;
        if (d < 10) d = '0' + d;
        if (m < 10) m = '0' + m;
        var ini = date.getFullYear() + '-' + m + '-01';
        var fin = date.getFullYear() + '-' + m + '-' + d;
        this.busqueda.fecha_ini = ini;
        this.busqueda.fecha_fin = fin;
        this.validarDatos();
      },
      onmsgpdf(msg) {
        let noti = { group: 'auth', title: '', text: msg, duration: 5000 };
        this.$notify(noti);
      },
      eliminarInscripcion(programa) {
        var vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${this.idNewInscripcion}`;
        window.console.log(url);
        xaxios
          .delete(url)
          .then((res) => {
            window.console.log(res, programa);
            vue.inscripciones = vue.inscripciones.filter((x) => x.id != vue.idNewInscripcion);
            let noti = { group: 'auth', title: '', text: res.data.data, duration: 5000 };
            vue.$notify(noti);
          })
          .catch((error) => {
            window.console.error(error);
            this.activo = true;
            let noti = {
              group: 'auth',
              title: 'Se ha producido un error',
              text: error.response.data.data,
              duration: 10000,
              type: 'error',
            };
            vue.$notify(noti);
          });
      },
      myFunction1(filtro) {
        filtro = filtro.toUpperCase();
        var table, tr, tdd, td, i, j, txtValue;
        table = document.getElementById('midatatable');
        tr = table.getElementsByTagName('tr');

        for (i = 0; i < tr.length; i++) {
          tdd = tr[i].getElementsByTagName('td');
          for (j = 1; j < tdd.length; j++) {
            td = tdd[j];
            if (td) {
              txtValue = td.textContent;
              if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                tr[i].style.display = '';
                break;
              } else {
                tr[i].style.display = 'none';
              }
            }
          }
        }
      },

      // mio
      proceder_inscripcion(row) {  
        const e = row.estudiante;
        if(!e.seg_apellido) e.seg_apellido = '';
        const programa_id = row.programa.id;
        const asesor_id = row.asesor.id;
        const persona_id = row.estudiante.id;
        const inscripcion_id = row.id; 
        const persona_name = `${e.nombres} ${e.pri_apellido} ${e.seg_apellido}`;
        this.$router.push(`/prospectos_ins/${programa_id}?asesor_id=${asesor_id}&persona_id=${persona_id}&persona_name=${persona_name}&inscripcion_id=${inscripcion_id}`);
      },
      // ver_terminos(row){ 
      //   this.$refs.refterminos_y.openmodal(row)
      // },
      ver_historial_acad(row){ 
        this.$refs.refver_historial.openmodal(row)
      },
      open_verificar_documento(row){ 
        this.$refs.refverificar_documento.openmodal(row)
      },
      verInscripciones(programa) {  
        programa.loading = true;
        var sql = gql`query{ getPrograma(id:${programa.id}){ programa_modulos{ id, idmodulo,iddocente,idprograma,course_id, inicio, fin, programa{id,nombre_compuesto,plataforma_id} modulo{id, sigla,nombre}, docente{id,email,num_doc,nombres,pri_apellido,seg_apellido,usuario_moodle,clave_moodle,telefono1}, estado},id,plataforma_id, course_category_id,fase,modalidad,version,grupo,arte,fecha_inicio,fecha_fin,gestion,mod_finalizado,sucursal_id,estado,inscripciones{id,estado_ins},sede{id,nombre,unidad_negocio},universidad{id,nombre},codigo,nombre_compuesto,postgrado{id,nombre,area{id,nombre},categoria{id,nombre}}} }`;
        this.$apollo
          .query({ query: sql, variables: { cursor: this.cursor } })
          .then(({ data }) => {
            let datos = data.getPrograma;
            this.$store.dispatch('programa/addPrograma', datos);
            this.$store.dispatch('programa/selectPrograma', datos);
            this.$router.push({ name: 'programains' });
            programa.loading = false;
          })
          .catch(() => {
            programa.loading = false;
            this.$root.$notify.show(`Ocurrio un problema, intente mas tarde :)`, {color:'red',x: 'right',});
          });
      },

    },
    mounted() {
      let cargo = this.$store.state.CARGO;
      if (cargo) {
        this.ispermitidoporasesor = cargo.id >= 14;
      }
      this.is_ispi = this.$store.state.CARGO.sede.unidad_negocio == 14
      this.getFechasDefault();
      this.gen_nom_us();
    },
  };
</script>

<style>
.tabla-ins-wrapper {
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  max-height: 70vh;
  overflow-y: auto;
}
.tabla-ins {
  width: 100%;
  border-collapse: collapse;
}
.tabla-ins thead tr.tabla-ins-header {
  background-color: #4c7fb9 !important;
  color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 10;
}
.tabla-ins thead th {
  padding: 9px 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  border-right: 1px solid #1976d2;
  letter-spacing: 0.3px;
}
.tabla-ins tbody tr:nth-child(even) {
  background-color: #f5f8ff;
}
.tabla-ins tbody tr:nth-child(odd) {
  background-color: #ffffff;
}
.tabla-ins tbody tr:hover {
  background-color: #e3f2fd !important;
}
.tabla-ins tbody td {
  padding: 5px 8px;
  font-size: 12px;
  border-right: 1px solid #e8eaf6;
  border-bottom: 1px solid #eceff1;
  white-space: nowrap;
}
.tabla-ins .nro-col {
  color: #9e9e9e;
  text-align: center;
}
.tabla-ins .estado-col {
  font-weight: bold;
  font-size: 11px;
  text-align: center;
  white-space: nowrap;
}
.tabla-ins .wsp-link {
  text-decoration: none;
  color: #1b5e20;
}
.tabla-ins .wsp-link:hover {
  text-decoration: underline;
}

/* ── Date picker label ── */
.fecha-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #1565c0;
  margin-bottom: 3px;
  letter-spacing: 0.2px;
}
</style>
